var _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _ellipse4, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10.4062H0.5V13.0312C0.5 19.0891 5.87258 24 12.5 24C19.1274 24 24.5 19.0891 24.5 13.0312V10.4062Z",
    fill: "url(#paint0_linear_9_5856)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 10.9688,
    rx: 12,
    ry: 10.9688,
    fill: "url(#paint1_linear_9_5856)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 12.5,
    cy: 10.9688,
    rx: 12,
    ry: 10.9688,
    fill: "url(#paint2_linear_9_5856)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 10.9688,
    rx: 11.4375,
    ry: 10.4062,
    fill: "url(#paint3_linear_9_5856)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1562 11.0625C22.1562 15.869 17.8421 19.7812 12.5 19.7812C7.15786 19.7812 2.84375 15.869 2.84375 11.0625C2.84375 6.25596 7.15786 2.34375 12.5 2.34375C17.8421 2.34375 22.1562 6.25596 22.1562 11.0625Z",
    fill: "#FFF0A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1562 11.0625C22.1562 15.869 17.8421 19.7812 12.5 19.7812C7.15786 19.7812 2.84375 15.869 2.84375 11.0625C2.84375 6.25596 7.15786 2.34375 12.5 2.34375C17.8421 2.34375 22.1562 6.25596 22.1562 11.0625Z",
    stroke: "#F5EBB6",
    strokeWidth: 0.1875
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 12.5,
    cy: 10.9688,
    rx: 11.4375,
    ry: 10.4062,
    fill: "url(#paint4_linear_9_5856)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.523 5.25064C16.818 5.25064 18.973 6.96184 19.25 10.2234H16.4332C16.1714 8.39907 14.832 7.6884 12.523 7.6884C9.70619 7.6884 8.52078 8.73788 8.52078 11.0466C8.52078 13.3553 9.72134 14.4372 12.523 14.4372C14.8169 14.4372 16.1714 13.7107 16.4332 11.8698H19.25C18.973 15.1473 16.818 16.875 12.523 16.875C7.78203 16.875 5.75 14.8085 5.75 11.0466C5.75 7.28476 7.78203 5.25 12.523 5.25V5.25064Z",
    fill: "#DDA015"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M12.523 5.25064C16.818 5.25064 18.973 6.96184 19.25 10.2234H16.4332C16.1714 8.39907 14.832 7.6884 12.523 7.6884C9.70619 7.6884 8.52078 8.73788 8.52078 11.0466C8.52078 13.3553 9.72134 14.4372 12.523 14.4372C14.8169 14.4372 16.1714 13.7107 16.4332 11.8698H19.25C18.973 15.1473 16.818 16.875 12.523 16.875C7.78203 16.875 5.75 14.8085 5.75 11.0466C5.75 7.28476 7.78203 5.25 12.523 5.25V5.25064Z",
    fill: "url(#paint5_linear_9_5856)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_5856",
    x1: -0.109375,
    y1: 12.2086,
    x2: 25.4218,
    y2: 16.7843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0A410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793903,
    stopColor: "#DC9E13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_5856",
    x1: -0.0624998,
    y1: 0.375,
    x2: 26.1875,
    y2: 20.9062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_5856",
    x1: 0.209677,
    y1: 2.66939,
    x2: 23.1374,
    y2: 17.3605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_5856",
    x1: 0.59375,
    y1: 1.3125,
    x2: 24.4063,
    y2: 20.9062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_5856",
    x1: 0.785786,
    y1: 3.09499,
    x2: 22.5797,
    y2: 17.1244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_5856",
    x1: 2.20979,
    y1: 3.51122,
    x2: 19.8007,
    y2: 17.2915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinM);
export default __webpack_public_path__ + "static/media/coin-m.0a298adb9656b1288c844fdef8e9d293.svg";
export { ForwardRef as ReactComponent };